import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import axios from "axios";
import FintrxXLogo from "../../images/fintrx-logo-notification.png";

const firebaseConfig = {
    apiKey: "AIzaSyBhyVDqM0VHaeOPNY_qxGIW78Yw6hqWY_w",
    authDomain: "fintrx-push.firebaseapp.com",
    projectId: "fintrx-push",
    storageBucket: "fintrx-push.appspot.com",
    messagingSenderId: "704032062771",
    appId: "1:704032062771:web:70fd7eb2f316e750939246",
    measurementId: "G-ZR9R45R29E"
};

let app = null;
let messaging = null

export const isSupported = () =>
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window


if (isSupported()) {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);

    if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
        Notification.requestPermission().then(() => { console.log('permission granted') });
    }
}

export const initializeFirebase = (user, onlyBackground = true) => {
    if (false) {
        getToken(messaging, { vapidKey: 'BP04VGUbTWHONYLwv4g8lqXfRigNQGQxHIvnuhaQuZqpX9uhzmR0zZfZnUQOstrnKbibve-hVMzgnDvxsvBNI8I' }).then((currentToken) => {
            if (currentToken) {
                sendTokenToServer(currentToken, user)
            } else {
                console.log('No registration token available. Request permission to generate one.');

            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        });

        onMessage(messaging, async (payload) => {
            if (onlyBackground) return;

            const notification = new Notification(payload.data.title, {
                body: payload.data.body,
                icon: FintrxXLogo,
            });

            notification.onclick = (e) => {
                window.open(payload.data.url, "_blank");
            }
        });

        async function sendTokenToServer(currentToken, user) {
            await axios.put('/v1/user/users/update_notification_token', {token: currentToken}, {
                headers: {
                    'X-User-Email': user.email,
                    'X-User-Token': user.token,
                }});
        }
    }
}

export const removeTokenFromUser = (user) => {
    return axios.put('/v1/user/users/update_notification_token', {token: null}, {
        headers: {
            'X-User-Email': user.email,
            'X-User-Token': user.token,
        }
    });
}


